import React from 'react'

const Footer = () => {
  return (
    <footer className="w-full bg-[#131a27] text-gray-300 text-center py-8 text-sm mt-auto">
      © 2025 Lax Kwalaams Ferries. All rights reserved.
    </footer>
  )
}

export default Footer